// src/components/LoginForm.tsx
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import SimuladoLayout from "../layouts/default/Simulado.layout";
import Quizz from "../components/Quizz/Quizz";
import {useSimulado} from "../../core/hooks/useSimulado";
import { useEffect, useState } from "react";
import { Alternativa, Resolucao } from "../../sdk/@types";
import SimuladoSidebar from "../layouts/default/SimuladoSidebar";
import { Layout, notification } from "antd";

const schema = z.object({
  email: z.string().email("Invalid email"),
  password: z.string().min(6, "Min 6 chars"),
});

type FormData = z.infer<typeof schema>;

export default function RealizarSimulado() {
  const {fetchResolucoes, resolucao, updateResolucao} = useSimulado();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormData>({ resolver: zodResolver(schema) });

  const onSubmit = (data: FormData) => {
    console.log(data);
  };

  useEffect(()=>{
    const load = async () =>{
      await fetchResolucoes();
    }
    load();
  },[fetchResolucoes]);  

  const handleChoseItem = (item : Resolucao.ResolucaoQuestao, choice : Alternativa.Alternativa) =>{
    try{
      const updated : Resolucao.ResolucaoQuestao = {
        ...item,
        answer: choice,
        correct: !!choice.correct
      };

      updateResolucao(updated);
    }catch(err){
      notification.error({
        message: err instanceof Error ? err.message : "Houve um erro"
      });
    }
  }

  return (
    <SimuladoLayout>
      {/* Quem rola é a coluna de conteúdo do SimuladoLayout. Aqui havia um
          `h-[100%] overflow-y-auto`, que não rolava nada: `100%` de um pai sem
          altura definida vira a altura do conteúdo. */}
      <div>
        {resolucao && <Quizz key={resolucao.id} questionReceived={resolucao} onChose={handleChoseItem} />}
      </div>
    </SimuladoLayout>
  );
}
